import { render, staticRenderFns } from "./JobGradeTabs.vue?vue&type=template&id=3fb99653&"
import script from "./JobGradeTabs.vue?vue&type=script&lang=js&"
export * from "./JobGradeTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports